import React from 'react';
import PropTypes from 'prop-types';

import classnames from '../../utils/classnames';
import styles from './stylesheets/Text.module.css';

const propTypes = {
  muted: PropTypes.bool,
  right: PropTypes.bool,
  left: PropTypes.bool,
  center: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  inline: PropTypes.bool,
  children: PropTypes.node,
};

const defaultProps = {
  left: true,
  right: false,
  center: false,
  small: false,
  prefix: null,
  suffix: null,
  inline: false,
  className: null,
  muted: false,
  children: null,
};

const Text = ({
  muted,
  right,
  left,
  center,
  small,
  className,
  prefix,
  suffix,
  inline,
  children,
}) => {
  const Tag = inline ? 'span' : 'p';

  return (
    <Tag className={classnames([
      muted && styles.muted,
      left && styles.left,
      right && styles.right,
      center && styles.center,
      small && styles.small,
      className,
    ])}
    >
      {prefix}
      {children}
      {suffix}
    </Tag>
  );
};

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
